import { OnInit } from '@angular/core';
import { ResourceService } from '../../services/resource/resource.service';
import { OmapiIdsUtils } from '../utils/omapi-ids/omapi-ids-utils';
import { ProductTypeRenditionEnum } from '../../constants/renditions/product-type-rendition.constants';
var PriceComponent = /** @class */ (function () {
    function PriceComponent(resourceService) {
        this.resourceService = resourceService;
        this.rendition = ProductTypeRenditionEnum.default;
        this.StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;
        this.NetflixStandaloneProductTypeRendition = ProductTypeRenditionEnum.netflixStandalone;
        this.DisneyStandaloneProductTypeRendition = ProductTypeRenditionEnum.disneyStandalone;
    }
    Object.defineProperty(PriceComponent.prototype, "priceDetail", {
        get: function () {
            return this._priceDetail;
        },
        set: function (value) {
            this._priceDetail = value;
        },
        enumerable: true,
        configurable: true
    });
    PriceComponent.prototype.ngOnInit = function () {
        this.fetchBackgroundColor();
    };
    PriceComponent.prototype.fetchBackgroundColor = function () {
        var _this = this;
        if (this.omapiId) {
            this.resourceService.getColourForProduct(OmapiIdsUtils.getCorrectIdForResource(this.omapiId)).subscribe(function (color) { return _this._backgroundColor = color; });
        }
        else {
            // default background color for price box
            this._backgroundColor = '#64ae65';
        }
    };
    Object.defineProperty(PriceComponent.prototype, "backgroundColor", {
        get: function () {
            return this._backgroundColor;
        },
        enumerable: true,
        configurable: true
    });
    return PriceComponent;
}());
export { PriceComponent };
